import { SelectSearchField } from 'components'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'


const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
 * Search field to select lead source.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
const SalesAliasSelectSearchField = ({
  name,
  label,
  required,
  userId,
  productIdWithSellingPriceList,
  ...props
}) => {

  const { setFieldError, setFieldTouched, setFieldValue } = useFormikContext()

  const salesAliasList = [
    {
      label: "Jane",
      value: "Jane",
    },
    {
      label: "Valen",
      value: "Valen",
    },
    {
      label: "Martha",
      value: "Martha",
    },
    {
      label: "Sam",
      value: "Sam",
    },
    {
      label: "Marina",
      value: "Marina",
    },
    {
      label: "Kana",
      value: "Kana",
    },
    {
      label: "Vina",
      value: "Vina",
    },
    {
      label: "Rachel",
      value: "Rachel",
    },
    {
      label: "Gina",
      value: "Gina",
    },
    {
      label: "Luvi",
      value: "Luvi",
    },
    {
      label: "Vivi",
      value: "Vivi",
    },
    {
      label: "Edita",
      value: "Edita",
    },
    {
      label: "Andra",
      value: "Andra",
    },
    {
      label: "Vera",
      value: "Vera",
    },
    {
      label: "Rania",
      value: "Rania",
    },
    {
      label: "Alexa",
      value: "Alexa",
    },
    {
      label: "Yessy",
      value: "Yessy",
    },
    {
      label: "Leoni",
      value: "Leoni",
    },
    {
      label: "Tania",
      value: "Tania",
    },
    {
      label: "Karla",
      value: "Karla",
    },
    {
      label: "Other",
      value: "Other",
    },
  ]
  const [ filteredSalesAliasList, setFilteredSalesAliasList ] = useState(salesAliasList)
  const [ isSearchLoading, setSearchLoading ] = useState(false)

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    option.label
  )
  const getSelectedOptionLabel = (option) => (
    option
  )

  // handler to search
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    setFilteredSalesAliasByQuery(salesAliasList, searchText)
  }
  const setFilteredSalesAliasByQuery = (salesAliasList, searchText) => {
    if(searchText){
      setFilteredSalesAliasList(
        salesAliasList.filter(o => o.label.toLowerCase().includes(searchText))
      )
    }else{
      setFilteredSalesAliasList(salesAliasList)
    }
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search...'
      dataList={ filteredSalesAliasList }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      getSelectedOptionLabel={ getSelectedOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={(selectedOption) => {
        setFieldValue(name, selectedOption.value)
        setFieldTouched(name, true, false)
      }}
      { ...props }
    />
  )
}

SalesAliasSelectSearchField.propTypes    = propTypes
SalesAliasSelectSearchField.defaultProps = defaultProps

export default SalesAliasSelectSearchField
